// extracted by mini-css-extract-plugin
module.exports = {"block":"infobar_block__pvSs9","list":"infobar_list__24O8r container","item":"infobar_item__1gTQJ","text":"infobar_text__3Oppp"};